 <template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro Carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_cte_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro DOC Inicio</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_cte_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro DOC Fim</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nro NF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="obs"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Obs</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status_carga"
              :options="this.$parent.statusCargaOptions"
              track-by="value"
              label="label"
              placeholder="Status Carga"
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="dt_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Fim"
              v-model="dt_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj_origem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ origem</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj_des_rec"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ {{ labelDesRed }}</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_operacao"
              :options="this.$parent.tpOperacaoOptions"
              track-by="value"
              label="label"
              placeholder="Tipo operação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_processo"
              :options="this.$parent.tpProcessoOptions"
              track-by="value"
              label="label"
              placeholder="Tipo processo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_emi"
              :options="this.$parent.municipioOptions"
              track-by="value"
              label="label"
              placeholder="Município Emi."
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <multiselect
              v-model="uf_emi"
              :options="this.$parent.ufOptions"
              track-by="value"
              label="label"
              placeholder="UF Emi."
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="municipio_des_rec"
              :options="this.$parent.municipioOptions"
              track-by="value"
              label="label"
              :placeholder="'Município ' + labelDesRed"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="uf_des_rec"
              :options="this.$parent.ufOptions"
              track-by="value"
              label="label"
              :placeholder="'UF '+ labelDesRed"
              tag-placeholder=""
              select-label=""
              :hide-selected="true"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-container>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="recebedor"
                  value="1"
                  @input="ajustaLabel(recebedor)"
                  unchecked-value="2"
                >
                  Recebedor
                  <span
                    v-b-tooltip
                    title="Se marcado os filtros de Município e UF de destino passam a buscar dados de Recebedor"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
            </b-container>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      dt_emi_ini: "",
      dt_emi_fim: "",
      num_carga: "",
      num_fiscal_cte_ini: "",
      num_fiscal_cte_fim: "",
      obs: "",
      labelDesRed: "Destinatário",
      num_fiscal: "",
      recebedor: 2,
      cnpj_des_rec: "",
      municipio_des_rec: "",
      uf_des_rec: "",
      dt_emi_ini_label: "",
      dt_emi_fim_label: "",
      cnpj_origem: "",
      status_carga: [],
      status_bip: [],
      tp_operacao: [],
      tp_processo: [],
      municipio_emi: [],
      municipio_des: [],
      uf_emi: [],
      uf_des: [],
      cnpj_destinatario: "",
      data_filter: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
    this.recebedor = 2;
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_emi_ini_label = this.dt_emi_ini;
      this.dt_emi_fim_label = this.dt_emi_fim;
      this.dt_emi_ini = this.formatDateSubmit(this.dt_emi_ini);
      this.dt_emi_fim = this.formatDateSubmit(this.dt_emi_fim);
      this.data_filter = {
        num_carga: this.num_carga,
        obs: this.obs,
        num_fiscal_cte_ini: this.num_fiscal_cte_ini,
        num_fiscal_cte_fim: this.num_fiscal_cte_fim,
        num_fiscal: this.num_fiscal,
        status_carga: this.status_carga,
        recebedor: this.recebedor,
        dt_emi_ini: this.dt_emi_ini,
        dt_emi_fim: this.dt_emi_fim,
        cnpj_origem: this.cnpj_origem,
        cnpj_des_rec: this.cnpj_des_rec,
        municipio_des_rec: this.municipio_des_rec,
        uf_des_rec: this.uf_des_rec,
        tp_operacao: this.tp_operacao,
        tp_processo: this.tp_processo,
        municipio_emi: this.municipio_emi,
        uf_emi: this.uf_emi,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_emi_ini = this.dt_emi_ini_label;
      this.dt_emi_fim = this.dt_emi_fim_label;
    },
    resetFilter() {
      (this.num_carga = ""),
        (this.num_fiscal_cte_ini = ""),
        (this.num_fiscal_cte_fim = ""),
        (this.num_fiscal = ""),
        (this.status_carga = ""),
        (this.dt_emi_ini = ""),
        (this.dt_emi_fim = "");
      this.cnpj_origem = "";
      this.obs = "";
      this.cnpj_des_rec = "";
      this.municipio_des_rec = "";
      this.uf_des_rec = "";
      this.tp_operacao = "";
      this.recebedor = "";
      this.tp_processo = "";
      this.municipio_emi = "";
      this.uf_emi = "";
      this.$events.fire("filter-reset");
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    ajustaLabel(destino_recebedor) {
      if (destino_recebedor == 1) {
        this.labelDesRed = "Recebedor";
      } else {
        this.labelDesRed = "Destinatário";
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
